import { Container, Skeleton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import HtmlContent from "../../components/htmlContent";
import NavigationDrawer from "../../components/navigationDrawer";
import { allColors } from "../../constants";
import { getLegalContent } from "../../services/legalContentApiFn";

const PrivacyPolicy = () => {
  const [privacyPolicyHtml, setPrivacyPolicyHtml] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const handleGetContent = async (type) => {
    try {
      const response = await getLegalContent(type);
      if (response.data.status === "success") {
        const data = response.data.data;
        setPrivacyPolicyHtml(data.content);
      } else {
        console.error("Failed to fetch content:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching content:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetContent("privacy-policy");
  }, []);

  return (
    <NavigationDrawer>
      <Container
        sx={{
          maxWidth: "1300px !important",
          marginTop: "80px",
        }}
      >
        <Typography
          fontFamily="Raleway"
          fontSize={{ xs: "20px", sm: "35px", md: "42px" }}
          color={allColors.jetBlack}
          fontWeight="400"
          marginBottom="30px"
          textAlign="center"
        >
          Privacy Policy
        </Typography>

        {isLoading ? (
          <>
            {[...Array(8)].map((_, index) => (
              <Skeleton
                key={index}
                variant="text"
                height={24}
                width={`${85 - (index % 3) * 10}%`}
              />
            ))}
          </>
        ) : (
          <HtmlContent html={privacyPolicyHtml} />
        )}
      </Container>
    </NavigationDrawer>
  );
};

export default PrivacyPolicy;
